/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { ContactMemo, ContactMemoFromJSON, ContactMemoFromJSONTyped, ContactMemoToJSON } from './ContactMemo'

/**
 *
 * @export
 * @interface CreateContactMemoResponseData
 */
export interface CreateContactMemoResponseData {
  /**
   *
   * @type {ContactMemo}
   * @memberof CreateContactMemoResponseData
   */
  contactMemo?: ContactMemo
}

export function CreateContactMemoResponseDataFromJSON(json: any): CreateContactMemoResponseData {
  return CreateContactMemoResponseDataFromJSONTyped(json, false)
}

export function CreateContactMemoResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateContactMemoResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    contactMemo: !exists(json, 'contact_memo') ? undefined : ContactMemoFromJSON(json['contact_memo'])
  }
}

export function CreateContactMemoResponseDataToJSON(value?: CreateContactMemoResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    contact_memo: ContactMemoToJSON(value.contactMemo)
  }
}
